import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { ItemPriceRange as ItemPriceRangeType } from 'typings'
import { Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from './messages'

type ItemPriceRangeProps = {
  itemPriceRange: ItemPriceRangeType | undefined
}

export function ItemPriceRange(props: ItemPriceRangeProps) {
  const { formatMessage } = useIntl()
  const { formatCurrency } = useNumbers()
  const { itemPriceRange } = props

  if (!itemPriceRange) return null

  const { min, max } = itemPriceRange

  const getTooltipContent = () => {
    if (min !== undefined && max === undefined) {
      return formatMessage(
        { ...messages.itemPriceRange.min },
        {
          min: formatCurrency(min),
        }
      )
    }

    if (min === undefined && max !== undefined) {
      return formatMessage(
        { ...messages.itemPriceRange.max },
        {
          max: formatCurrency(max),
        }
      )
    }

    if (min !== undefined && max !== undefined) {
      return formatMessage(
        { ...messages.itemPriceRange.range },
        {
          max: formatCurrency(max),
          min: formatCurrency(min),
        }
      )
    }

    return ''
  }

  return (
    <Tooltip text={getTooltipContent()}>
      <Tag>
        <FormattedMessage {...messages.itemPriceRange.title} />
      </Tag>
    </Tooltip>
  )
}
